import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * Thin fixed bar at top of viewport that tracks scroll progress.
 * Uses Framer Motion useScroll + useSpring for smooth tracking.
 */
function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        background: 'linear-gradient(90deg, #F26522, #F7B32B)',
        transformOrigin: '0% 50%',
        scaleX,
        zIndex: 100,
      }}
      aria-hidden="true"
    />
  );
}

export default ScrollProgressBar;
